import { clearUserState } from "@/api/auth/auth";
import composeRoute from "@/api/routes/utils/route-utils/route-utils";
import { LOGIN_ROUTE } from "@/routing/app-routes";
import { jwtDecode } from "jwt-decode";

export const decodeJWT = (jwt) => {
  try {
    return jwtDecode(jwt);
  } catch (error) {
    console.error(error);
    clearUserState();
    window.location.href = composeRoute(LOGIN_ROUTE);
  }
};

export const safeDecodeURI = (uri) => {
  //make sure any % is encoded if it doesn't look like it is encoded already
  return decodeURIComponent(encodePercent(uri));
};

export const safeEncodeURI = (uri) => {
  //make sure any % is encoded if it doesn't look like it is encoded already
  return encodeURIComponent(encodePercent(uri));
};

const encodePercent = (uri) => {
  return uri.replace(/%(?![0-9][\da-f]+)/gi, "%25");
};
